import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=4138a383&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&media=print&lang=scss&"
import style1 from "./Details.vue?vue&type=style&index=1&id=4138a383&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138a383",
  null
  
)

export default component.exports